module.exports = __webpack_public_path__ + "static/media/Salazzle_gaussian2.2ddc6542.png";